import { create } from 'zustand';
import client from '../api/client';

const useAuthStore = create((set) => ({
  user: null,
  token: localStorage.getItem('token') || null,

  login: async (email, password) => {
    const params = new URLSearchParams({ username: email, password });
    const { data } = await client.post('/auth/login', params);
    localStorage.setItem('token', data.access_token);
    set({ token: data.access_token });
    const me = await client.get('/users/me');
    set({ user: me.data });
  },

  register: async (name, email, password) => {
    await client.post('/auth/register', { name, email, password });
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  fetchMe: async () => {
    try {
      const { data } = await client.get('/users/me');
      set({ user: data });
    } catch {
      localStorage.removeItem('token');
      set({ user: null, token: null });
    }
  },
}));

export default useAuthStore;
